/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Quote_1_WhoInputs */

const da_forside_quote_1_who = /** @type {(inputs: Forside_Quote_1_WhoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matematiklærer, 9. klasse`)
};

/** @type {(inputs: Forside_Quote_1_WhoInputs) => LocalizedString} */
const en_forside_quote_1_who = da_forside_quote_1_who;

/**

* @param {Forside_Quote_1_WhoInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_quote_1_who = /** @type {((inputs?: Forside_Quote_1_WhoInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Quote_1_WhoInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_quote_1_who(inputs)
	return /** @type {LocalizedString} */ ("Matematiklærer, 9. klasse")
});